import { useEffect } from 'react';

export type UseBlockNavigationProps = {
  isDirty: boolean;
};

export function useBlockNavigation({ isDirty }: UseBlockNavigationProps) {
  // Browser-level navigation (refresh, close tab)
  useEffect(() => {
    const handleBeforeUnload = (e: BeforeUnloadEvent) => {
      if (isDirty) {
        e.preventDefault();
        e.returnValue = ''; // Triggers browser confirm dialog
      }
    };
    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  }, [isDirty]);
}
